import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { userApi } from "../services/userApi";
import { SocialMediaTask } from "../services/CreateSocialMediaTaskApi";
import { AddMoneyApi } from "../services/addMoneyApi";
import { buySellApi } from "../services/buySell";
import { withdrawApi } from "../services/withdrawApi";
import { redeemApi } from "../services/redeemApi";
import { leaderBoardApi } from "../services/leaderBoardApi";
import loginPopupDisplayReducer from "./Slices/loginPopupDisplaySlice";
import smTaskSubTaskReducer from "./Slices/smTaskSubTaskSlice";
import userProfileReducer from "./Slices/userProfileSlice";
import { SocialMediaHandle } from "../services/socialMediaHandle";
import { stakeApi } from "../services/stakeApi";
import { tradeApi } from "../services/tradeApi";
import {quizApi} from "../services/quizApi"
import { spinWheelApi } from "../services/spinWheelApi";
import { feedbackApi } from "../services/feedbackApi";
import { chatApi } from "../services/chatApi";
import { socialApi } from "../services/socialApi";
import { platformListingApi } from "../services/platformListingApi";
import { pointTransferApi } from "../services/pointTransferApi";
import { dailyStreakApi } from "../services/dailyStreakApi";
import whatsAppModalPopupDisplayReducer from "./Slices/whatsAppModalPopupDisplay";

export const store = configureStore({
  reducer: {
    [userApi.reducerPath]: userApi.reducer,
    [SocialMediaTask.reducerPath]: SocialMediaTask.reducer,
    [AddMoneyApi.reducerPath]: AddMoneyApi.reducer,
    [buySellApi.reducerPath]: buySellApi.reducer,
    [withdrawApi.reducerPath]: withdrawApi.reducer,
    [redeemApi.reducerPath]: redeemApi.reducer,
    [leaderBoardApi.reducerPath]: leaderBoardApi.reducer,
    [quizApi.reducerPath]: quizApi.reducer,
    [socialApi.reducerPath]: socialApi.reducer,
    [pointTransferApi.reducerPath]: pointTransferApi.reducer,

    // quizApi
    [SocialMediaHandle.reducerPath]: SocialMediaHandle.reducer,
    [stakeApi.reducerPath]: stakeApi.reducer,
    [tradeApi.reducerPath]: tradeApi.reducer,
    loginPopupDisplay: loginPopupDisplayReducer,
    smTaskSubTask: smTaskSubTaskReducer,
    userProfile: userProfileReducer,
    whatsAppModalPopupDisplay: whatsAppModalPopupDisplayReducer,
    [spinWheelApi.reducerPath]: spinWheelApi.reducer,
    [feedbackApi.reducerPath]: feedbackApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    [platformListingApi.reducerPath]: platformListingApi.reducer,
    [dailyStreakApi.reducerPath]: dailyStreakApi.reducer,

  },
  devTools: false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      userApi.middleware,
      SocialMediaTask.middleware,
      AddMoneyApi.middleware,
      buySellApi.middleware,
      withdrawApi.middleware,
      redeemApi.middleware,
      leaderBoardApi.middleware,
      quizApi.middleware,
      socialApi.middleware,
      pointTransferApi.middleware,

      SocialMediaHandle.middleware,
      stakeApi.middleware,
      tradeApi.middleware,
      spinWheelApi.middleware,
      feedbackApi.middleware,
      chatApi.middleware,
      platformListingApi.middleware,
      dailyStreakApi.middleware,

    ]),
  /** here will be more reducer */
});

setupListeners(store.dispatch);